import * as Parser from "papaparse";

export class ImportCsvBaseService {
    public static $inject: string[] = [
        "$q",
        "$translate",
        "itemService"
    ];

    protected $t;
    protected globalDeferred;
    protected sale;
    protected summary;

    constructor(
        protected $q: ng.IQService,
        $translate: ng.translate.ITranslateService,
        protected itemService
    ) {
        this.$t = $translate.instant;
    }

    protected guessDelimiter(input) {
        const delimChoices = [";", ",", "\t", "|"];
        let bestLinebreak, bestColumnDelimiter, bestDelta, fieldCountPrevRow;

        for (let i = 0; i < delimChoices.length; i++) {
            const delim = delimChoices[i];
            let delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
            fieldCountPrevRow = undefined;

            const preview = Parser.parse(input, {
                delimiter: delim,
                newline: "",
                preview: 10
            });

            bestLinebreak = preview.meta?.linebreak;

            for (let j = 0; j < preview.data.length; j++) {
                if (preview.data[j].length === 1 && preview.data[j][0].length === 0) {
                    emptyLinesCount++;
                    continue;
                }
                const fieldCount = preview.data[j].length;
                avgFieldCount += fieldCount;

                if (typeof fieldCountPrevRow === "undefined") {
                    fieldCountPrevRow = fieldCount;
                    continue;
                } else {
                    if (fieldCount > 1) {
                        delta += Math.abs(fieldCount - fieldCountPrevRow);
                        fieldCountPrevRow = fieldCount;
                    }
                }
            }

            if (preview.data.length > 0) {
                avgFieldCount /= (preview.data.length - emptyLinesCount);
            }

            if ((typeof bestDelta === "undefined" || delta < bestDelta) && avgFieldCount > 1.99) {
                bestDelta = delta;
                bestColumnDelimiter = delim;
            }
        }


        return { bestLinebreak, bestColumnDelimiter };
    }

    protected notify(action, data) {
        this.globalDeferred.notify({ action, data });
    }

    protected sendSummary() {
        this.notify("setSummary", this.summary);
    }
}
